/* eslint-disable no-unused-vars */
import * as types from '@/modules/templates/store/types';
import * as contentTypes from '@/modules/content/store/types';

const getters = {
  [types.GET_SELECTED_CREATIVE_TEMPLATE_ID]: (state, getter, rootState, rootGetters) => {
    const { activeCreatives } = rootState.content;
    const selectedCreative = rootGetters[`content/${contentTypes.GET_CURRENT_SELECTED_CREATIVE}`];
    if (activeCreatives.length === 0 || selectedCreative.id === 0) return 0;
    const activeCreative = activeCreatives.filter((creative) => creative.id === selectedCreative.id)[0];
    return activeCreative.creativeTemplateId;
  },
  [types.GET_TEMPLATE_EDITABLE_PROPERTIES]: (state, getter) => {
    const { creativesTemplatesEditableProperties } = state;
    if (creativesTemplatesEditableProperties.length === 0) return [];
    const selectedCreativeTemplateId = getter.GET_SELECTED_CREATIVE_TEMPLATE_ID;
    if (selectedCreativeTemplateId === 0) return [];
    if (!creativesTemplatesEditableProperties[selectedCreativeTemplateId]) return [];
    return creativesTemplatesEditableProperties[selectedCreativeTemplateId]
      .map((property) => property.propertyKey);
  },
};

export default getters;
